import NavBar from "./Header/NavBar";
export default function Header() {
  return (
    <>
      <NavBar />
    </>
  );
}
